'use client';

import { c as _c } from "react/compiler-runtime";
import { useSession } from 'next-auth/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import TradeProgramForm from './TradeProgramForm';
const TradeFormSection = () => {
  const $ = _c(5);
  const {
    data: session
  } = useSession();
  const isTradeMember = session?.user?.tradeAccount === 1;
  if (isTradeMember) {
    return null;
  }
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center mb-3 lg:mb-4"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-xl lg:text-2xl text-primary mr-2" /><h2 className="text-lg lg:text-xl font-light">Join the Trade Program</h2></div>;
    t1 = <p className="text-sm lg:text-base text-light mb-2 lg:mb-4">All design professionals are welcome — interior designers, architects, builders, and allied trade are encouraged to apply. At hive, we've spent more than two decades cultivating relationships with the A+D community, and we know that the right resources can make all the difference on a project. Our trade program is designed to give you exactly that: competitive pricing, knowledgeable support, and direct access to the world's most respected design brands — all in one place. Because we are independent, design-obsessed, and deeply familiar with the brands we carry, our team brings a level of expertise and genuine enthusiasm that's increasingly rare in this industry.</p>;
    t2 = <p className="text-sm lg:text-base text-light mb-2 lg:mb-4">Membership is complimentary, and the process is straightforward. Simply complete the form below and a hive trade specialist will be in touch to confirm your membership within one business day. Once you're in, you'll have everything you need to specify and source with confidence — and a team that's genuinely invested in the success of your projects.</p>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="lg:w-1/3">{t0}{t1}{t2}<p className="text-sm lg:text-base">Questions? We're happy to help. Call us at <a href="tel:18666634483" className="font-medium hover:text-primary">(866) 663-4483</a></p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section id="trade-form" className="site-padding mb-8 lg:mb-12 scroll-mt-24"><div className="flex flex-col lg:flex-row gap-6 lg:gap-16">{t3}<div className="lg:w-2/3"><TradeProgramForm /></div></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default TradeFormSection;